import React from 'react';
import TourOverlay from '@/components/help/TourOverlay';
import type { ScreenTourState } from '@/hooks/useScreenTour';

interface ScreenTourLayerProps {
  tour: ScreenTourState;
}

/** Renders the tour overlay when a screen tour is active. */
const ScreenTourLayer: React.FC<ScreenTourLayerProps> = ({ tour }) =>
  tour.isOpen ? (
    <TourOverlay
      steps={tour.steps}
      stepIdx={tour.stepIdx}
      onNext={tour.goNext}
      onPrev={tour.goPrev}
      onClose={tour.finishTour}
    />
  ) : null;

export default ScreenTourLayer;
